import { isPlainObject } from "lodash";
import { useContext } from "react";
import { useFetch } from "use-http";

import cgiGRP2Context from "../contexts/cgiGRP2Context";

export default function useCGIGRP2(...args) {
  const { apiPath } = useContext(cgiGRP2Context);
  if (typeof args[0] === "string") {
    args[0] = `${apiPath}${args[0]}`;
  } else {
    args.unshift(apiPath);
  }
  if (isPlainObject(args[1]) || args[1] == null) {
    args[1] = { cachePolicy: "no-cache", ...args[1] };
  }
  return useFetch(...args);
}
